<template>
  <ModalDialog
    ref="dialog"
    title="Select Glass"
    submitTitle="Update"
    :scrollable="true"
    :submitDisabled="submitDisabled"
    icon="fa-layer-group"
    @closed="onClosed"
    @submitted="onSubmitted">

    <Spinner v-if="loading" />
    <div v-if="!loading && stockData">
      <ContentTitle>Glass Sizes Available</ContentTitle>
      <ContentSubTitle>Select the glass size to use</ContentSubTitle>
      <StaticDataTable class="static-table-list">
        <template v-slot:header>
          <tr>
            <th>Size (HxW) mm</th>
            <th>Selection</th>
          </tr>
        </template>
        <template v-slot:body>
          <template v-for="glassSize in availableGlassSizeList">
            <tr :key="glassSize.id">
              <td class="font-weight-bold">{{glassSize.height}} x {{glassSize.width}}</td>
              <td>
                <FormCheckbox :value="glassSize.id == selectedGlassSizeId" @change="glassSizeChanged(glassSize.id, $event)" />
              </td>
            </tr>
          </template>
        </template>
      </StaticDataTable>
      <p v-if="orderedGlassHeight && orderedGlassWidth">Ordered Glass Size: <span class="font-weight-bold">{{orderedGlassHeight}} x {{orderedGlassWidth}}</span></p>
      <p class="text-center font-italic" v-if="availableGlassSizeList.length == 0">No glass sizes found</p>
      <div v-if="isCustomGlassSizeAvailable && selectedGlassSizeId != 0">
        <FormHorizontalRule />
        <ContentTitle>Glass Size Override</ContentTitle>
        <ContentSubTitle>If enabled, a custom size will be used to request from the supplier. All incoming glass stock will be associated with the selected parent glass size above</ContentSubTitle>
        <FormRow label="Override Size">
          <FormCheckbox v-model="optionIsCustomStockLinkedGlassSize" />
        </FormRow>
        <FormRow label="Custom Size" :fieldCount="2" v-if="optionIsCustomStockLinkedGlassSize">
          <template v-slot:field1>
            <FormInputText type="number" v-model="optionCustomGlassHeight" placeholder="Height" prepend="Height" addon="mm" field="optionCustomGlassHeight" />
          </template>
          <template v-slot:field2>
            <FormInputText type="number" v-model="optionCustomGlassWidth" placeholder="Width" prepend="Width" addon="mm" field="optionCustomGlassWidth" />
          </template>
        </FormRow>



      </div>
    </div>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

import StaticDataTable from '@/components/table/staticDataTable.vue'

export default {
  name: 'OrderSelectGlassSizeDialog',
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog,
    StaticDataTable
  },
  props: {
    stockId: Number,
    glassSizeId: Number,
    orderedGlassWidth: Number,
    orderedGlassHeight: Number,
    isCustomGlassSizeAvailable: Boolean,
    isCustomStockLinkedGlassSize: Boolean,
    customGlassWidth: Number,
    customGlassHeight: Number
  },
  data() {
    return {
      dialogForm: {},
      selectedGlassSizeId: this.$props.glassSizeId,
      optionIsCustomStockLinkedGlassSize: this.$props.isCustomStockLinkedGlassSize,
      optionCustomGlassWidth: parseInt(this.$props.customGlassWidth || 0),
      optionCustomGlassHeight: parseInt(this.$props.customGlassHeight || 0),
      loading: false,
      stockData: null
    }
  },
  mounted() {
    this.requestData()
  },
  computed: {
    availableGlassSizeList() {
      if(!this.stockData)
        return []
      return this.stockData.glassSizeList.filter(glassSize => glassSize.isActive)
    },
    submitDisabled() {
      return !this.selectedGlassSizeId
    }
  },
  methods: {
    show() {
      this.dialogForm = { }

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    glassSizeChanged(glassSizeId, selected) {
      if(selected) {
        let changed = (this.selectedGlassSizeId != glassSizeId)
        this.selectedGlassSizeId = glassSizeId
        
        // Reset
        if(changed) {
          this.optionIsCustomStockLinkedGlassSize = false
          let glassSize = this.stockData.glassSizeList.find(glassSize => glassSize.id == this.selectedGlassSizeId)
          if(glassSize) {
            this.optionCustomGlassWidth = glassSize.width
            this.optionCustomGlassHeight = glassSize.height
          }
        }
      } else if(glassSizeId == this.selectedGlassSizeId) {
        this.selectedGlassSizeId = 0
      }
    },
    requestData() {
      this.loading = true

      this.$apiService.inventoryService.getStock(this.stockId)
      .then(response => {
        this.$data.stockData = response.data
      })
      .finally(() => {
        this.loading = false
      })
    },

    onSubmitted() {
      let glassSize = this.stockData.glassSizeList.find(glassSize => glassSize.id == this.selectedGlassSizeId)
      if(!glassSize)
        return

      var glassSizeInfo = {
        id: this.selectedGlassSizeId,
        width: glassSize.width,
        height: glassSize.height,
        isCustomStockLinkedGlassSize: false
      }
      if(this.isCustomGlassSizeAvailable) {
        glassSizeInfo.isCustomStockLinkedGlassSize = this.optionIsCustomStockLinkedGlassSize
        glassSizeInfo.width = this.optionCustomGlassWidth
        glassSizeInfo.height = this.optionCustomGlassHeight
      }

      this.modalClosed(glassSizeInfo)
      this.hide()
    }
  }
}
</script>